import React, { Component } from "react";
import "./App.css";
import Navi from "../navi/Navi";
import Title from "../title/Title";
import Skills4 from "../skills/Skills4";
import Info from "../info/Info";
import About from "../about/About";
import Footer from "../footer/Footer";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container,Row } from "reactstrap";

export default class App extends Component {

  componentDidMount() {
    window.scrollTo(0,1)
  }

  render() {
    return (
      <div id="home" className="all_page">
          <div  className="all_page2">
          <Navi></Navi>
          <Title></Title>
          <div className="index mb-0">
            <About href="about"></About>
            <Info></Info>
           <Row id="courses"  className="courses-row">
           <h1 className="title course-title">Taken Courses</h1>
           <Container className="cont-slider">
           <Skills4></Skills4>
             </Container> 
           </Row>
           
            <Footer></Footer>
          </div>
        </div>
      </div>
    );
  }
}
